import { alpha, darken } from "@material-ui/core/styles/colorManipulator";

export const getTintPalette = (color: string) => ({
  main: color,
  dark: darken(color, 0.25),
  light: alpha(color, 0.8),
  lighter: alpha(color, 0.2),
  lightest: alpha(color, 0.1),
});
